import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { CreateReview, IReview, ReviewListResponse, ReviewQueryParams, UpdateReview } from '@frontend/review/types';

export class ReviewClient extends APIClient {
    public static readonly endpoint = '/review-api/v1';

    public static async fetchReviews(queryParams?: ApiQueryParams<ReviewQueryParams>): Promise<ReviewListResponse> {
        return await this.apiPaginated<ReviewListResponse, ReviewQueryParams>(`${this.endpoint}/reviews`, queryParams);
    }

    public static async resolveReviews(ids: string[]): Promise<ReviewListResponse> {
        const response = await this.post(`${this.endpoint}/reviews-resolve`, { ids: ids });
        return await this.handleResponse<ReviewListResponse>(response);
    }

    public static async deleteReviews(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/reviews-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postReview(accountId: string, body: CreateReview, includeAccessToken = true, withCredentials?: Token): Promise<IReview> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/reviews`, body, includeAccessToken, withCredentials);
        return await this.handleResponse<IReview>(response);
    }

    public static async fetchReview(accountId: string, reviewId: string): Promise<IReview> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/reviews/${reviewId}`);
        return await this.handleResponse<IReview>(response);
    }

    public static async patchReview(accountId: string, reviewId: string, body: UpdateReview): Promise<IReview> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/reviews/${reviewId}`, body);
        return await this.handleResponse<IReview>(response);
    }

    public static async deleteReview(accountId: string, reviewId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/reviews/${reviewId}`);
        return await this.handleVoidResponse(response);
    }
}
